import { createIdempotencyKey } from 'src/utils/idempotency.utils'

/**
 * Generates a fresh key for one canonical create-vendor request. Modern
 * browsers provide `randomUUID`; the fallback keeps older runtimes usable
 * without importing an ESM-only dependency into Jest's CommonJS graph.
 */
export function createVendorIdempotencyKey(): string {
  return createIdempotencyKey('vendor')
}
